module.exports = __webpack_public_path__ + "static/media/export.c9bb4f2a.svg";